import { render, staticRenderFns } from "./CreateRegion.vue?vue&type=template&id=88a86fb0&"
import script from "./CreateRegion.vue?vue&type=script&lang=js&"
export * from "./CreateRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateRegion.vue"
export default component.exports